const getPrescriberCityStateZip = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber['Address Information']) {
    const address = prescriber['Address Information'];
    return `${address.City}, ${address.State} ${address['Zip Code']}`.toUpperCase();
  }
  if (patient.Prescriber[0]) {
    const address = patient.Prescriber[0]['Address Information'];
    return `${address.City}, ${address.State} ${address['Zip Code']}`.toUpperCase();
  }
  return null;
};

export default getPrescriberCityStateZip;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberCityStateZip.js